module.exports = "/_next/static/images/white-zpay@3x-f0c33324e38979e6c3a4963862f895c4.png";